module.exports = {"id":"186912","name":"Christian Träsch","rating":"75","photo":"./data/images/photos/1/186912.png","club":{"name":"FC Ingolstadt","logo":"./data/images/clubs/FCIngolstadt.png"},"positions":["MDC","DD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ChristianTrasch0.json
// module id = 804
// module chunks = 0